
const ReportsTranslation = {
    
    // Report preview
    _reportPreviewFooterDetails: {
        pt_br: 'Gerado em {date} às {hour} pelo usuário {user}',
        en_us: 'Generated on {date} at {hour} by user {user}',
        es_es: 'Generado el {date} a las {hour} por el usuario {user}'
    },
    
    
    // Reports
    // Room Overview
    _roomOverviewDescription: {
        pt_br: 'Listagem com a situação atual das UHs',
        en_us: 'List with current room situation',
        es_es: 'Listado con la situación actual de las habitaciones'
    },

    _roomOverviewEmptyRoomList: {
        pt_br: 'Nenhuma UH encontrada com os filtros selecionados',
        en_us: 'No rooms found with the selected filters',
        es_es: 'No se encontraron habitaciones con los filtros seleccionados'
    },


    // Room Log
    _roomLogDescription: {
        pt_br: 'Log de alterações realizadas por UH',
        en_us: 'Log of changes made by room',
        es_es: 'Registro de cambios realizados por habitación'
    },

    _roomLogEmptyRoomList: {
        pt_br: 'Nenhum registro de log encontrado com os filtros selecionados',
        en_us: 'No log records found with selected filters',
        es_es: 'No se encontraron registros con los filtros seleccionados'
    },

    _roomLogChangeGovernanceStatusAction: {
        pt_br: 'Alteração do status de governança',
        en_us: 'Changing governance status',
        es_es: 'Cambiar el estado de gobernanza'
    },

    _roomLogChangeDoNotDisturbStatusAction: {
        pt_br: 'Alteração do status de "não perturbe"',
        en_us: 'Changing "do not disturb" status',
        es_es: 'Cambiar el estado de "no molestar"'
    },


    // Statistical Log
    _statisticalLogDescription: {
        pt_br: 'Estatísticas operacionais por usuário',
        en_us: 'Operational statistics by user',
        es_es: 'Estadísticas operativas por usuario'
    },

    _statisticalLogEmptyUserList: {
        pt_br: 'Nenhum usuário encontrado com os filtros selecionados',
        en_us: 'No users found with the selected filters',
        es_es: 'No se han encontrado usuarios con los filtros seleccionados'
    },

    _statisticalLogAverageOfPerRoom: {
        pt_br: 'Média de {value} por UH',
        en_us: 'Average of {value} per room',
        es_es: 'Promedio de {value} por habitación'
    }
}

export default ReportsTranslation;